// src/features/tag/useTags.ts

import { useQuery } from '@tanstack/react-query';
import { TagApi } from './TagApi';
import { TAG_QUERY_KEYS } from '@/lib/constants/tag';
import { useAuth } from '@/features/auth/hooks/useAuth';

export interface UseTagsResult {
  tags: string[];
  isLoading: boolean;
  isError: boolean;
}

export function useTags(): UseTagsResult {
  const { selectedCId } = useAuth();

  const query = useQuery({
    queryKey: TAG_QUERY_KEYS.list(selectedCId ?? 0),
    queryFn: async () => {
      const response = await TagApi.getTags(selectedCId!);
      return response.tags.sort((a, b) =>
        a.localeCompare(b, undefined, { sensitivity: 'base' })
      );
    },
    enabled: selectedCId != null,
    staleTime: 2 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });

  return {
    tags: query.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
  };
}
